/* src/app/modules/shared/components/column/column-appearance/column-appearance.component.scss */
app-column-appearance {
  display: contents;
}
/*# sourceMappingURL=column-appearance.component.css.map */
